export const MEETTRAINER_REQUEST_BASE = 'individualcoach/MEETTRAINER_REQUEST_BASE';
export const MEETTRAINER_REQUEST_QUERY = 'individualcoach/MEETTRAINER_REQUEST_QUERY';
export const LIBRARY_LOADING = 'individualcoach/LIBRARY_LOADING';
export const LIBRARY_LOADED = 'individualcoach/LIBRARY_LOADED';
export const FILTER_LOADING = 'individualcoach/FILTER_LOADING';
export const FILTER_LOADED = 'individualcoach/FILTER_LOADED';
export const MEETTRAINER_REQUEST_ERROR = 'individualcoach/MEETTRAINER_REQUEST_ERROR';
export const MEETTRAINER_REQUEST_UPDATING = 'individualcoach/MEETTRAINER_REQUEST_UPDATING';